import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PartnerUserSelectModal from "../common/PartnerUserSelectModal";
import ItemSelectModal from "../common/ItemSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];
function OutgoingUpdateModal({ title, onClose, id, originRows, handleView, userTypeModalOption, qualityYnModalOption, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [originItemRows, setOriginItemRows] = useState([]);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [originLotRows, setOriginLotRows] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    outgoing_id: null,
    outgoing_number: '',
    outgoing_date:'',
    outgoing_partner_id: 0,
    outgoing_partner_name: '',
    outgoing_partner_manager: '',
    outgoing_partner_manager_phone: '',
    outgoing_partner_manager_mail: '',
    outgoing_partner_delivery_post: '',
    outgoing_partner_delivery_address: '',
    outgoing_partner_delivery_address_add: '',
    outgoing_bigo: '',
    outgoing_order_id: null,
    outgoing_order_number: '',
    outgoing_ref_outgoing_id: null
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectOrderModalOpen, setSelectOrderModalOpen] = useState(false);
  const [isSelectOutgoingModalOpen, setSelectOutgoingModalOpen] = useState(false);
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');
  const [selectLotData, setSelectLotData] = useState('');
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.outgoing_user_id, row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));
  
  const handleInitSelect = () => {
    const t0 = performance.now();

    // 초기화
    tmpRealFiles = [];
    setUpdateUserRows([]);
    setUpdateItemRows([]);
    setUpdateLotRows([]);
    setUpdateFileRows([]);

    const rows = originRows || [];
    const first = rows[0];
    if (!first) return;

    // 입력 세팅
    setInputs({
      outgoing_id: Number(first.outgoing_id),
      outgoing_number: first.outgoing_number,
      outgoing_date: first.outgoing_date,
      outgoing_partner_id: Number(first.outgoing_partner_id),
      outgoing_partner_name: first.outgoing_partner_name,
      outgoing_partner_manager: first.outgoing_partner_manager,
      outgoing_partner_manager_phone: first.outgoing_partner_manager_phone,
      outgoing_partner_manager_mail: first.outgoing_partner_manager_mail,
      outgoing_partner_delivery_post: first.outgoing_partner_delivery_post,
      outgoing_partner_delivery_address: first.outgoing_partner_delivery_address,
      outgoing_partner_delivery_address_add: first.outgoing_partner_delivery_address_add,
      outgoing_bigo: first.outgoing_bigo,
      outgoing_order_id: Number(first.outgoing_order_id),
      outgoing_order_number: first.outgoing_order_number,
      outgoing_ref_outgoing_id: Number(first.outgoing_ref_outgoing_id),
    });

    // 1패스 분류 + 중복제거(Map)
    const itemMap = new Map(); // key: outgoing_item_seq
    const userMap = new Map(); // key: outgoing_user_seq
    const fileMap = new Map(); // key: outgoing_file_id
    const lotMap  = new Map(); // key: `${lot_outgoing_item_lot_seq}|${outgoing_item_id}`

    // item_id → item_seq 빠른 역참조용 (upper_id 계산용)
    const itemIdToSeq = new Map(); // key: outgoing_item_id -> value: outgoing_item_seq

    for (const r of rows) {
      if (r.outgoing_item_seq !== undefined && !itemMap.has(r.outgoing_item_seq)) {
        const spec = (
                      (r.outgoing_item_spec || '') +
                      appStore.ITEM_FULL_SPEC_MAKE(
                        r.outgoing_item_width,
                        r.outgoing_item_depth,
                        r.outgoing_item_height
                      )
                    ).trim();
        const item = {
          id: r.outgoing_item_seq,
          outgoing_item_id: r.outgoing_item_id,
          outgoing_item_name: r.outgoing_item_name,
          outgoing_item_spec: spec,
          outgoing_item_count: r.outgoing_item_count,
          outgoing_quality_exam_yn: r.outgoing_quality_exam_yn,
          outgoing_item_bigo: r.outgoing_item_bigo,
          row_type: 'O',
          update_type: 'N',
        };
        itemMap.set(r.outgoing_item_seq, item);
        itemIdToSeq.set(r.outgoing_item_id, r.outgoing_item_seq);
      }

      if (r.outgoing_user_seq !== undefined && !userMap.has(r.outgoing_user_seq)) {
        userMap.set(r.outgoing_user_seq, {
          id: r.outgoing_user_seq,
          outgoing_user_id: r.outgoing_user_id,
          outgoing_user_name: r.outgoing_user_name,
          outgoing_user_dept_name: r.outgoing_user_dept_name,
          outgoing_user_position_name: r.outgoing_user_position_name,
          outgoing_user_type: r.outgoing_user_type,
          outgoing_user_bigo: r.outgoing_user_bigo,
          row_type: 'O',
          update_type: 'N',
        });
      }

      if (r.outgoing_file_id !== undefined && !fileMap.has(r.outgoing_file_id)) {
        fileMap.set(r.outgoing_file_id, {
          id: r.outgoing_file_id,
          file_name_sever: r.outgoing_file_name_sever,
          file_size: r.outgoing_file_size,
          file_type: r.outgoing_file_type,
          file_extension: r.outgoing_file_extension,
          file_name: r.outgoing_file_name,
          file_type_name: r.outgoing_file_type_name,
          file_size_dp: r.outgoing_file_size_dp,
          reg_user_name: r.outgoing_file_user_name,
          reg_datetime: Moment(r.outgoing_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
          row_type: 'O',
          update_type: 'N',
        });
      }
    }

    axios.get('/api/p/Outgoing/LotList',
        {
        params : {
          outgoing_id : id
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
      if(response.data.length > 0){

        var LotData = (response.data).filter((item, index) => {
          return (
            (response.data).findIndex((item2, index2) => {
              return typeof item.lot_outgoing_item_lot_seq !== 'undefined' && item.lot_outgoing_item_lot_seq === item2.lot_outgoing_item_lot_seq;
            }) === index
          );
        });

        setLotRows(LotData.map((item, index) => ({
            id: item.lot_outgoing_item_lot_seq,
            upper_id: item.outgoing_item_seq,
            lot_no: item.lot_outgoing_item_lotno,
            lot_outgoing_item_id: item.lot_outgoing_item_id,
            lot_outgoing_item_name: item.lot_outgoing_item_name,
            lot_outgoing_item_spec: item.lot_outgoing_item_spec,
            lot_outgoing_quality_exam_yn: item.lot_outgoing_quality_exam_yn,
            lot_outgoing_save_workplace_id: item.lot_outgoing_save_workplace_id,
            lot_outgoing_save_workplace_name: item.lot_outgoing_save_workplace_name,
            lot_outgoing_save_warehouse_id: item.lot_outgoing_save_warehouse_id,
            lot_outgoing_save_warehouse_name: item.lot_outgoing_save_warehouse_name,
            lot_outgoing_save_section_id: item.lot_outgoing_save_section_id,
            lot_outgoing_save_section_name: item.lot_outgoing_save_section_name,
            row_type: 'O',
            update_type: 'N',
        })));

        setUpdateLotRows(LotData.map((item, index) => ({
            id: item.lot_outgoing_item_lot_seq,
            upper_id: item.outgoing_item_seq,
            lot_no: item.lot_outgoing_item_lotno,
            lot_outgoing_item_id: item.lot_outgoing_item_id,
            lot_outgoing_item_name: item.lot_outgoing_item_name,
            lot_outgoing_item_spec: item.lot_outgoing_item_spec,
            lot_outgoing_quality_exam_yn: item.lot_outgoing_quality_exam_yn,
            lot_outgoing_save_workplace_id: item.lot_outgoing_save_workplace_id,
            lot_outgoing_save_workplace_name: item.lot_outgoing_save_workplace_name,
            lot_outgoing_save_warehouse_id: item.lot_outgoing_save_warehouse_id,
            lot_outgoing_save_warehouse_name: item.lot_outgoing_save_warehouse_name,
            lot_outgoing_save_section_id: item.lot_outgoing_save_section_id,
            lot_outgoing_save_section_name: item.lot_outgoing_save_section_name,
            row_type: 'O',
            update_type: 'N',
        })));

        setOriginLotRows(LotData.map((item, index) => ({
            id: item.lot_outgoing_item_lot_seq,
            upper_id: item.outgoing_item_seq,
            lot_no: item.lot_outgoing_item_lotno,
            lot_outgoing_item_id: item.lot_outgoing_item_id,
            lot_outgoing_item_name: item.lot_outgoing_item_name,
            lot_outgoing_item_spec: item.lot_outgoing_item_spec,
            lot_outgoing_quality_exam_yn: item.lot_outgoing_quality_exam_yn,
            lot_outgoing_save_workplace_id: item.lot_outgoing_save_workplace_id,
            lot_outgoing_save_workplace_name: item.lot_outgoing_save_workplace_name,
            lot_outgoing_save_warehouse_id: item.lot_outgoing_save_warehouse_id,
            lot_outgoing_save_warehouse_name: item.lot_outgoing_save_warehouse_name,
            lot_outgoing_save_section_id: item.lot_outgoing_save_section_id,
            lot_outgoing_save_section_name: item.lot_outgoing_save_section_name,
            row_type: 'O',
            update_type: 'N',
        })));
      }
    })
    .catch((error) => {
        appStore.capture();
    });

    const t1 = performance.now();

    // 정렬
    const itemRows = Array.from(itemMap.values()).sort((a, b) => a.id - b.id);
    const lotRows  = Array.from(lotMap.values()).sort((a, b) =>
      String(a.lot_no).localeCompare(String(b.lot_no), undefined, { numeric: true, sensitivity: 'base' })
    );
    const userRows = Array.from(userMap.values()).sort((a, b) => a.id - b.id);
    const fileRows = Array.from(fileMap.values()).sort((a, b) => a.id - b.id);

    const t2 = performance.now();

    // setState
    setItemRows(itemRows);
    setOriginItemRows(itemRows);
    
    setUserRows(userRows);

    setFileRows(fileRows);
    setOriginFileRows(fileRows);

    // newFileID 갱신
    let maxFileId = typeof newFileID === 'number' ? newFileID : 0;
    for (const f of fileRows) if (typeof f.id === 'number' && f.id >= maxFileId) maxFileId = f.id + 1;
    newFileID = maxFileId;

    const t3 = performance.now();
    console.log(`[outgoing] build ${(t1 - t0).toFixed(1)}ms, sort ${(t2 - t1).toFixed(1)}ms, setState ${(t3 - t2).toFixed(1)}ms, total ${(t3 - t0).toFixed(1)}ms`);
  };


  const handleSetting = () => {
    setItemColumns([
        {
          field: 'actions',
          headerName: '동작',
          width: 55,
          type:'actions',
          disableClickEventBubbling: true,
          getActions: (params) => [
              ((params.row.update_type === "U")? 
              <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
              : (params.row.row_type === "A" && params.row.update_type === "N")? 
              <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
              :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
              )
            ],
          headerAlign: 'center', 
          align:'center'
        },
        { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
        { field: 'outgoing_item_id', headerName: 'outgoing_item_id', headerAlign: 'center', align:'center' },
        { field: 'outgoing_item_name', headerName: '품목', width: 180, headerAlign: 'center', align:'left' },
        { field: 'outgoing_item_spec', headerName: '규격', width: 200, headerAlign: 'center', align:'left' },
        { field: 'outgoing_item_count', headerName: '출하수량', type: 'number', width: 100, headerAlign: 'center', align:'right', editable: true },
        { field: 'outgoing_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 100, 
          valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
            qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
          editable: true, headerAlign: 'center', align:'center' },
        { field: 'outgoing_item_bigo', headerName: '비고', width: 250, headerAlign: 'center', align:'left', editable: true },
        { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
        { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' }
    ]);

    setLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
      { field: 'lot_outgoing_item_id', headerName: 'lot_outgoing_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_outgoing_item_name', headerName: '품목', width: 130, headerAlign: 'center', align:'left' },
      { field: 'lot_outgoing_item_spec', headerName: '규격', width: 185, headerAlign: 'center', align:'left' },
      { field: 'lot_outgoing_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'lot_outgoing_save_workplace_id', headerName: 'lot_outgoing_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_outgoing_save_workplace_name', headerName: '사업장',width: 110, headerAlign: 'center'},
      { field: 'lot_outgoing_save_warehouse_id', headerName: 'lot_outgoing_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_outgoing_save_warehouse_name', headerName: '창고', width: 110, headerAlign: 'center', align:'left' },
      { field: 'lot_outgoing_save_section_id', headerName: 'lot_outgoing_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_outgoing_save_section_name', headerName: '구역',width: 110, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'outgoing_user_id', headerName: 'outgoing_user_id', width: 0, headerAlign: 'center' },
      { field: 'outgoing_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setItemColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      outgoing_item_id: false,
      outgoing_item_name: true,
      outgoing_item_spec: true,
      outgoing_item_count: true,
      outgoing_quality_exam_yn: false,
      outgoing_item_bigo: true,
      row_type: false,
      update_type: false
    });

    setLotColumnVisibilityModel({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_outgoing_item_id: false,
      lot_outgoing_item_name: true,
      lot_outgoing_item_spec: true,
      lot_outgoing_quality_exam_yn: false,
      lot_outgoing_save_workplace_id: false,
      lot_outgoing_save_workplace_name: true,
      lot_outgoing_save_warehouse_id: false,
      lot_outgoing_save_warehouse_name: true,
      lot_outgoing_save_section_id: false,
      lot_outgoing_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      outgoing_user_id: false,
      outgoing_user_name: true,
      outgoing_user_dept_name: true,
      outgoing_user_position_name: true,
      outgoing_user_type: true,
      outgoing_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: updateFlag,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    outgoing_item_id: false,
    outgoing_item_name: true,
    outgoing_item_spec: true,
    outgoing_item_count: true,
    outgoing_quality_exam_yn: true,
    outgoing_item_bigo: false,
    row_type: false,
    update_type: false
  });

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_outgoing_item_id: false,
    lot_outgoing_item_name: true,
    lot_outgoing_item_spec: true,
    lot_outgoing_quality_exam_yn: true,
    lot_outgoing_save_workplace_id: false,
    lot_outgoing_save_workplace_name: true,
    lot_outgoing_save_warehouse_id: false,
    lot_outgoing_save_warehouse_name: true,
    lot_outgoing_save_section_id: false,
    lot_outgoing_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    outgoing_user_id: false,
    outgoing_user_name: true,
    outgoing_user_dept_name: true,
    outgoing_user_position_name: true,
    outgoing_user_type: true,
    outgoing_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: updateFlag,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    tmpRealFiles = [];
    handleSetting();
    handleInitSelect();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        outgoing_item_id: '',
        outgoing_item_name: '',
        outgoing_item_spec: '',
        outgoing_item_count: '',
        outgoing_quality_exam_yn: 'N',
        outgoing_item_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [itemRows]);
  
  useEffect(() => {
    // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        outgoing_user_id: '',
        outgoing_user_name: '',
        outgoing_user_dept_name: '',
        outgoing_user_position_name: '',
        outgoing_user_type: '',
        outgoing_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    var array = [];
    for(var i=0; i<originFileRows.length; i++){
      var tmp_id = originFileRows[i].id;
      var tmp_file_name_sever = originFileRows[i].file_name_sever;
      var tmp_file_name = originFileRows[i].file_name;
      var tmp_file_size = originFileRows[i].file_size;
      var tmp_file_size_dp = originFileRows[i].file_size_dp;
      var tmp_file_type = originFileRows[i].file_type;
      var tmp_file_type_name  = originFileRows[i].file_type_name;
      var tmp_file_extension = originFileRows[i].file_extension;
      var tmp_file_reg_user_name = originFileRows[i].reg_user_name;
      var tmp_file_reg_datetime = originFileRows[i].reg_datetime;

      var tmpYN = 'N'
      for(var j=0; j<fileRows.length; j++){
        //origin에는 있고 file에는 없으면 -> O / D
        if(fileRows[j].id === originFileRows[i].id && fileRows[j].file_name_sever === originFileRows[i].file_name_sever && fileRows[j].reg_user_name === originFileRows[i].reg_user_name && fileRows[j].reg_datetime === originFileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        array.push({
          id: tmp_id,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_file_reg_user_name,
          reg_datetime: tmp_file_reg_datetime,
          row_type:'O',
          update_type: 'D'
        })
      }
    }

    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      var tmpYN = 'N'
      for(var j=0; j<originFileRows.length; j++){
        if(originFileRows[j].id === fileRows[i].id && originFileRows[j].file_name_sever === fileRows[i].file_name_sever && originFileRows[j].reg_user_name === fileRows[i].reg_user_name && originFileRows[j].reg_datetime === fileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){ // 신규Row(A, N)는 제외함.
          array.push({
            id: tmp_id,
            file_name_sever: tmp_file_name_sever,
            file_size: tmp_file_size,
            file_type: tmp_file_type,
            file_extension: tmp_file_extension,
            file_type_name: tmp_file_type_name,
            file_name: tmp_file_name,
            file_size_dp: tmp_file_size_dp,
            reg_user_name: tmp_file_reg_user_name,
            reg_datetime: tmp_file_reg_datetime,
            row_type:'A',
            update_type: 'U'
          })
        }
      }
    }
    setUpdateFileRows(array);
    
    let ADD_YN = 'Y'
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N' && i === (fileRows.length-1)){
        ADD_YN = 'N'
      }else if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        setFileRows((fileRows) => fileRows.filter((data) => data.id !== fileRows[i].id));
        ADD_YN = 'N'
      }
    }
    
    if(ADD_YN === 'Y' && updateFlag){
      newFileID = Number(newFileID) + 1;
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(newFileID),
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시

    setSelectModalTitle('출하처 목록')
    setSelectPartnerModalOpen(true);
    
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'outgoing_partner_manager_phone'){ // 전화번호인 경우
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
};

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    if(newRow.outgoing_item_count > 99999){
      return;
    }
    // 출하 품목 Rows Update
    // 날짜형식 fomat 맞춰주기
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.outgoing_item_id !== oldRow.outgoing_item_id || newRow.outgoing_item_name !== oldRow.outgoing_item_name || newRow.outgoing_item_count !== oldRow.outgoing_item_count || newRow.outgoing_quality_exam_yn !== oldRow.outgoing_quality_exam_yn || newRow.outgoing_item_bigo !== oldRow.outgoing_item_bigo){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_outgoing_item_id = '';
      var row_outgoing_item_name = '';
      var row_outgoing_item_spec = '';
      var row_outgoing_item_count = '';
      var row_outgoing_quality_exam_yn = 'N';
      var row_outgoing_item_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.outgoing_item_id !== '' || newRow.outgoing_item_name !== '' || newRow.outgoing_item_spec !== '' || newRow.outgoing_item_count !== '' || newRow.outgoing_item_bigo !== '' || newRow.outgoing_quality_exam_yn !== 'N'){
          row_outgoing_item_id = newRow.outgoing_item_id;
          row_outgoing_item_name = newRow.outgoing_item_name;
          row_outgoing_item_spec = newRow.outgoing_item_spec;
          row_outgoing_item_count = newRow.outgoing_item_count;
          row_outgoing_quality_exam_yn = newRow.outgoing_quality_exam_yn;
          row_outgoing_item_bigo = newRow.outgoing_item_bigo;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        itemRows.map((data) => data.id === newRow.id 
          && (data.outgoing_item_id !== newRow.outgoing_item_id || data.outgoing_item_name !== newRow.outgoing_item_name || data.outgoing_item_spec !== newRow.outgoing_item_spec || data.outgoing_item_count !== newRow.outgoing_item_count || data.outgoing_quality_exam_yn !== newRow.outgoing_quality_exam_yn || data.outgoing_item_bigo !== newRow.outgoing_item_bigo)?
          (
            row_outgoing_item_id = data.outgoing_item_id,
            row_outgoing_item_name = data.outgoing_item_name,
            row_outgoing_item_spec = data.outgoing_item_spec,
            row_outgoing_item_count = data.outgoing_item_count,
            row_outgoing_quality_exam_yn = data.outgoing_quality_exam_yn,
            row_outgoing_item_bigo = data.outgoing_item_bigo
          ):""
        )
      }
      
      if(row_outgoing_item_id === '' && row_outgoing_item_name === '' && row_outgoing_item_spec === '' && row_outgoing_item_count === '' && row_outgoing_quality_exam_yn === 'N' && row_outgoing_item_bigo === ''){
        // 1. 값이 수정되지 않은 경우.
        if(updateItemRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateItemRows.length);
          setUpdateItemRows(updateItemRows.filter((data) => data.id !== newRow.id));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
          searchLotRow(itemRows, newNoDataArray, 'O');
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }
        
        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateItemRows.length);
          setUpdateItemRows(updateItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          searchLotRow(itemRows, newUpdateDataArray, 'A');
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateItemRows.length);
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          searchLotRow(itemRows, newUpdateDataArray, 'A');
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  // item row 업데이트와 동시에 lot row 조회
  const searchLotRow = (tempItemRow, tempNewUpdateData, tempType) => { 
    if(tempNewUpdateData.outgoing_item_count === null || tempNewUpdateData.outgoing_item_count === ''){
      tempNewUpdateData.outgoing_item_count = 0
      tempType = 'D'
    }
    
    if(tempType === 'D'){ // 삭제인 경우 'D'

      setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows((lotRows) => lotRows.map((data) => data.upper_id === tempNewUpdateData.id? { ...data, 'update_type':'D' } : data  ));
    } else if(tempType === 'O'){ // 신규와 동일한 경우 'O'

      setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));

    } else if(tempType === 'A'){ // 업데이트 'A'
      
      if(tempNewUpdateData.outgoing_item_count === 0 || tempNewUpdateData.outgoing_item_count === '' || tempNewUpdateData.outgoing_item_count === null || itemRows.find((data) => data.id === tempNewUpdateData.id).outgoing_item_id !== tempNewUpdateData.outgoing_item_id){
      }else if(tempNewUpdateData.outgoing_item_count < 0){
        
        Swal.fire({
          title: '<p style="color:red">출하 수량 오류</p>',
          text: '출하 수량은 음수가 될 수 없습니다.',
          confirmButtonText: '확인'
        });

        processItemRowUpdate(
          {
            id: tempNewUpdateData.id,
            outgoing_item_id: tempNewUpdateData.outgoing_item_id,
            outgoing_item_name: tempNewUpdateData.outgoing_item_name,
            outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
            outgoing_item_count: '',
            outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
            outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
            row_type:tempNewUpdateData.row_type,
            update_type: tempNewUpdateData.update_type,
          },
          {
            id: tempNewUpdateData.id,
            outgoing_item_id: tempNewUpdateData.outgoing_item_id,
            outgoing_item_name: tempNewUpdateData.outgoing_item_name,
            outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
            outgoing_item_count: tempNewUpdateData.outgoing_item_count,
            outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
            outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
            row_type:tempNewUpdateData.row_type,
            update_type: tempNewUpdateData.update_type,
          }
        )
      }else{
        if(tempNewUpdateData.outgoing_item_id == '' || tempNewUpdateData.outgoing_item_count == '' || tempNewUpdateData.outgoing_item_count == '0'){
          return;
        }
        
        if(itemRows.find((data) => data.id === tempNewUpdateData.id).outgoing_item_id !== tempNewUpdateData.outgoing_item_id
        || itemRows.find((data) => data.id === tempNewUpdateData.id).outgoing_item_count !== tempNewUpdateData.outgoing_item_count){
          // 품목ID, 수량이 변경되었을때 Lot 삭제 후 (Item 재고 조회)
          setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
          setUpdateLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));

          axios.get('/api/Common/StockFIFOInfo',
              {
              params : {
                  item_id : tempNewUpdateData.outgoing_item_id,
                  item_count: tempNewUpdateData.outgoing_item_count
              }
            },
            { withCredentials: true }
          )
          .then((response) => {
            var start_lot_id = Number(appStore.getMaxListID(lotRows))+1;
            var create_lot_array = [];
            var lot_array = response.data;
            // Limit이 걸려져있어서 length와 item_count가 동일함.
            if(lot_array.length >= Number(tempNewUpdateData.outgoing_item_count)){
              for(var i=0; i<Number(tempNewUpdateData.outgoing_item_count); i++){
                create_lot_array.push(
                  {
                    id: (start_lot_id+i),
                    upper_id :tempNewUpdateData.id,
                    lot_no: lot_array[i].item_lotno,
                    lot_outgoing_item_id : tempNewUpdateData.outgoing_item_id,
                    lot_outgoing_item_name: tempNewUpdateData.outgoing_item_name,
                    lot_outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
                    lot_outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
                    lot_outgoing_save_workplace_id: (typeof lot_array[i].item_lot_save_workplace_id === 'undefined'?null:lot_array[i].item_lot_save_workplace_id),
                    lot_outgoing_save_workplace_name: (typeof lot_array[i].item_lot_save_workplace_name === 'undefined'?null:lot_array[i].item_lot_save_workplace_name),
                    lot_outgoing_save_warehouse_id: (typeof lot_array[i].item_lot_save_warehouse_id === 'undefined'?null:lot_array[i].item_lot_save_warehouse_id),
                    lot_outgoing_save_warehouse_name: (typeof lot_array[i].item_lot_save_warehouse_name === 'undefined'?null:lot_array[i].item_lot_save_warehouse_name),
                    lot_outgoing_save_section_id: (typeof lot_array[i].item_lot_save_section_id === 'undefined'?null:lot_array[i].item_lot_save_section_id),
                    lot_outgoing_save_section_name: (typeof lot_array[i].item_lot_save_section_name === 'undefined'?null:lot_array[i].item_lot_save_section_name),
                    row_type: 'A',
                    update_type: 'U'
                  }
                )
              }
              setLotRows((lotRows) => [...lotRows, ...create_lot_array ]);
              setUpdateLotRows((updateLotRows) => [...updateLotRows, ...create_lot_array ]);
            }else{

              Swal.fire({
                title: '<p style="color:red">출하 품목 재고 부족</p>',
                text: '품목의 가용 재고가 ' + (String(lot_array.length)).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' 입니다.',
                confirmButtonText: '확인'
              });
              
              processItemRowUpdate(
                {
                  id: tempNewUpdateData.id,
                  outgoing_item_id: tempNewUpdateData.outgoing_item_id,
                  outgoing_item_name: tempNewUpdateData.outgoing_item_name,
                  outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
                  outgoing_item_count: '',
                  outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
                  outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
                  row_type:tempNewUpdateData.row_type,
                  update_type: tempNewUpdateData.update_type,
                },
                {
                  id: tempNewUpdateData.id,
                  outgoing_item_id: tempNewUpdateData.outgoing_item_id,
                  outgoing_item_name: tempNewUpdateData.outgoing_item_name,
                  outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
                  outgoing_item_count: tempNewUpdateData.outgoing_item_count,
                  outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
                  outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
                  row_type:tempNewUpdateData.row_type,
                  update_type: tempNewUpdateData.update_type,
                }
              )
            }
          });
        }else if(itemRows.find((data) => data.id === tempNewUpdateData.id).outgoing_quality_exam_yn !== tempNewUpdateData.outgoing_quality_exam_yn){
          setLotRows(lotRows.map((data) => data.upper_id === tempNewUpdateData.id && data.lot_outgoing_quality_exam_yn !== tempNewUpdateData.outgoing_quality_exam_yn ? { ...data, lot_outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn, update_type: 'U' } : data ));
          setUpdateLotRows(updateLotRows.map((data) => data.upper_id === tempNewUpdateData.id && data.lot_outgoing_quality_exam_yn !== tempNewUpdateData.outgoing_quality_exam_yn? { ...data, lot_outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn, update_type: 'U' } : data ));
        }
      }
    } 
  };

  const processLotRowUpdate = (newRow, oldRow) => {
    // 날짜형식 fomat 맞춰주기
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.lot_no !== oldRow.lot_no && newRow.lot_outgoing_item_id !== oldRow.lot_outgoing_item_id && newRow.lot_outgoing_quality_exam_yn !== oldRow.lot_outgoing_quality_exam_yn){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_lot_no = '';
      var row_lot_outgoing_quality_exam_yn = 'N';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.lot_no !== oldRow.lot_no || newRow.lot_outgoing_quality_exam_yn !== oldRow.lot_outgoing_quality_exam_yn){
          
          row_lot_no = newRow.lot_no;
          row_lot_outgoing_quality_exam_yn = newRow.lot_outgoing_quality_exam_yn;
        
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        lotRows.map((data) => data.id === newRow.id 
          && (data.lot_no !== newRow.lot_no || data.lot_outgoing_quality_exam_yn !== newRow.lot_outgoing_quality_exam_yn)?
          (
            row_lot_no = data.lot_no,
            row_lot_outgoing_quality_exam_yn = data.row_lot_outgoing_quality_exam_yn
          ):""
        )
      }
      
      if(row_lot_no === '' && row_lot_outgoing_quality_exam_yn === 'N'){
        // 1. 값이 수정되지 않은 경우.
        if(updateLotRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.filter((data) => data.id !== newRow.id));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateLotRows.length; i++) {
          if(updateLotRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateLotRows.length);
          setUpdateLotRows(prevRows => [...prevRows, newUpdateDataArray]);
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    //자원 담당자 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우
    
    if(oldRow.outgoing_user_id !== newRow.outgoing_user_id || oldRow.outgoing_user_type !== newRow.outgoing_user_type || oldRow.outgoing_user_bigo !== newRow.outgoing_user_bigo){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_outgoing_user_id = '';
      var row_outgoing_user_name = '';
      var row_outgoing_user_type = '';
      var row_outgoing_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.outgoing_user_id !== '' || newRow.outgoing_user_name !== '' || (newRow.outgoing_user_type !== '' && newRow.outgoing_user_type !== null) || newRow.outgoing_user_bigo !== '' ){
          row_outgoing_user_id = newRow.outgoing_user_id;
          row_outgoing_user_name = newRow.outgoing_user_name;
          row_outgoing_user_type = newRow.outgoing_user_type;
          row_outgoing_user_bigo = newRow.outgoing_user_bigo;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        userRows.map((data) => data.id === newRow.id 
          && (data.outgoing_user_id !== newRow.outgoing_user_id || data.outgoing_user_name !== newRow.outgoing_user_name || data.outgoing_user_type !== newRow.outgoing_user_type || data.outgoing_user_bigo !== newRow.outgoing_user_bigo )?
          (
            row_outgoing_user_id = data.outgoing_user_id,
            row_outgoing_user_name = data.outgoing_user_name,
            row_outgoing_user_type = data.outgoing_user_type,
            row_outgoing_user_bigo = data.outgoing_user_bigo
          ):""
        )
      }
      
      if(row_outgoing_user_id === '' && row_outgoing_user_name === '' && row_outgoing_user_bigo === '' && (row_outgoing_user_type === '' || row_outgoing_user_type === null)){
        // 1. 값이 수정되지 않은 경우.
        if(updateUserRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateUserRows.length);
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const itemAddClick = (object) => {
    //출하 품목 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        outgoing_item_id: '',
        outgoing_item_name: '',
        outgoing_item_spec: '',
        outgoing_item_count: '',
        outgoing_quality_exam_yn: 'N',
        outgoint_item_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        outgoing_item_id: object.row.outgoing_item_id,
        outgoing_item_name: object.row.outgoing_item_name,
        outgoing_item_spec: object.row.outgoing_item_spec,
        outgoing_item_count: object.row.outgoing_item_count,
        outgoing_quality_exam_yn: object.row.outgoing_quality_exam_yn,
        outgoint_item_bigo: object.row.outgoint_item_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
  };

  const itemDeleteClick = (object) => {
    //출하 품목 삭제 버튼
    if(object.row.row_type === 'O'){
      setUpdateItemRows(prevRows => [...prevRows, {
        id: object.row.id,
        outgoing_item_id: object.row.outgoing_item_id,
        outgoing_item_name: object.row.outgoing_item_name,
        outgoing_item_spec: object.row.outgoing_item_spec,
        outgoing_item_count: object.row.outgoing_item_count,
        outgoing_quality_exam_yn: object.row.outgoing_quality_exam_yn,
        outgoint_item_bigo: object.row.outgoint_item_bigo,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    }
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
    searchLotRow(itemRows, object.row, 'D');
  };

  const userAddClick = (object) => {
    //입고 담당자 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        outgoing_user_id: '',
        outgoing_user_name: '',
        outgoing_user_dept_name: '',
        outgoing_user_position_name: '',
        outgoing_user_type: '',
        outgoing_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        outgoing_user_id: object.row.outgoing_user_id,
        outgoing_user_name: object.row.outgoing_user_name,
        outgoing_user_dept_name: object.row.outgoing_user_dept_name,
        outgoing_user_position_name: object.row.outgoing_user_position_name,
        outgoing_user_type: object.row.outgoing_user_type,
        outgoing_user_bigo: object.row.outgoing_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    //입고 담당자 삭제 버튼
    if(object.row.row_type === 'O'){
      setUpdateUserRows(prevRows => [...prevRows, {
        id: object.row.id,
        outgoing_user_id: object.row.outgoing_user_id,
        outgoing_user_name: object.row.outgoing_user_name,
        outgoing_user_dept_name: object.row.outgoing_user_dept_name,
        outgoing_user_position_name: object.row.outgoing_user_position_name,
        outgoing_user_type: object.row.outgoing_user_type,
        outgoing_user_bigo: object.row.outgoing_user_bigo,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    }
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.id=object.row.id;
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {
      tmpRealFiles = []; // 수정은 초기화용과 업로드용을 따로 둔다.
      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
        tmpRealFiles.push(input.files[i]);
      }

      var array = [];
      for(var i=0; i<tmpRealFiles.length; i++){
        var tmp_sever_file_name = tmpRealFiles[i].name;
        var tmp_file_name = tmpRealFiles[i].name;
        var tmp_file_size = tmpRealFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(tmpRealFiles[i].size);
        var tmp_file_type = tmpRealFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(tmpRealFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);
        
        newFileID = Number(newFileID) + 1;
        array.push({
          id: Number(newFileID),
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        });
      }
      setFileRows((fileRows) => [...fileRows, ...array]);
    };
  };

  const fileDeleteClick = (object) => {
    //파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }

    if(object.row.row_type === 'O'){
      setUpdateFileRows(prevRows => prevRows.some(r => r.id === object.row.id && r.update_type === 'D') ? prevRows : [...prevRows, { 
        id: object.row.id,
        file_name_sever: object.row.outgoing_file_name_sever,
        file_size: object.row.outgoing_file_size,
        file_type: object.row.outgoing_file_type,
        file_extension: object.row.outgoing_file_extension,
        file_name: object.row.outgoing_file_name,
        file_type_name: object.row.outgoing_file_type_name,
        file_size_dp: object.row.outgoing_file_size_dp,
        reg_user_name: object.row.outgoing_file_user_name,
        reg_datetime: Moment(object.row.outgoing_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
        row_type: 'O',
        update_type: 'D'
       }]);
    }else{
      setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    }
    
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //파일 다운로드
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };

  const handleOutgoingCancel = (event) => {
    // 출하 취소 // 혹은 원복
    var status_str = ''
    var change_status = ''
    if(originRows[0].outgoing_status === 'S'){ // 출하취소
      status_str = '취소'
      change_status = 'D'
    } else { // 출하원복
      status_str = '원복'
      change_status = 'S'
    }

    Swal.fire({
      title: '출하번호 '+originRows[0].outgoing_number+' 출하 ' + status_str,
      text: '출하를 '+ status_str +' 하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '예', 
      cancelButtonText: '아니오',
      confirmButtonColor: '#0067a3',
      cancelButtonColor: '#d33',
    }).then(result => {
      if (result.isConfirmed) {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.post('/api/p/Outgoing/Update', new URLSearchParams({
          cancel_outgoing_id: originRows[0].outgoing_id,
          change_status: change_status
        }),
        { withCredentials: true })
        .then(function (response) {
          if(response.status === 200){
            if(response.data === 'Y'){
              Swal.fire({
                title: '출하번호 '+originRows[0].outgoing_number+' ' + status_str + ' 완료',
                text: '정상적으로 출하가 '+status_str+' 되었습니다.',
                confirmButtonText: '확인',
                timer: 5000,
                timerProgressBar: true
              }).then((result) => {
                handleView();
              });
            }else{
              Swal.fire({
                title: '<p style="color:red">출하 원복 오류</p>',
                text: response.data,
                confirmButtonText: '확인'
              }).then((result) => {
                handleView();
              });
            }
            
          }else{
              appStore.capture();
          }
        })
        .catch(function (error) {
          appStore.capture();
          console.log("네트워크 실패", error);
        })
        .finally(() => {
          appStore.setLoading(false); 
        });
      }
    })
  }

  const handleOnCellClick = (params) => {
    if(params.field === 'outgoing_item_name' || params.field === 'outgoing_item_spec' 
      || params.field === 'outgoing_save_workplace_name' || params.field === 'outgoing_save_warehouse_name' || params.field === 'outgoing_save_section_name'){
      if(params.field === 'outgoing_item_name' || params.field === 'outgoing_item_spec'){
        setSelectModalTitle('품목 목록');
        setSelectItemModalOpen(true);
      }
      setSelectItemData({
        id: params.row.id,
        outgoing_item_id: params.row.outgoing_item_id,
        outgoing_item_name: params.row.outgoing_item_name,
        outgoing_item_spec: params.row.outgoing_item_spec,
        outgoing_item_count: params.row.outgoing_item_count,
        outgoing_quality_exam_yn: params.row.outgoing_quality_exam_yn,
        outgoing_item_bigo: params.row.outgoing_item_bigo,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'outgoing_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        outgoing_user_id: params.row.outgoing_user_id,
        outgoing_user_name: params.row.outgoing_user_name,
        outgoing_user_dept_name: params.row.outgoing_user_dept_name,
        outgoing_user_position_name: params.row.outgoing_user_position_name,
        outgoing_user_type: params.row.outgoing_user_type,
        outgoing_user_bigo: params.row.outgoing_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handlePartnerUserClick = (object) => {
    //출하처 모달에서 클릭한 값으로 출하처 및 담당자 데이터 설정함.
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email
    var partner_delivery_post = object.partner_head_address_post === undefined?'':object.partner_head_address_post
    var partner_delivery_address = object.partner_head_address === undefined?'':object.partner_head_address
    var partner_delivery_address_add = object.partner_head_address_addition === undefined?'':object.partner_head_address_addition

    const nextInputs = {
        ...inputs,
        ["outgoing_partner_id"]: object.id,
        ["outgoing_partner_name"]: object.partner_name,
        ["outgoing_partner_manager"]: partner_user_name,
        ["outgoing_partner_manager_phone"]: partner_user_phone,
        ["outgoing_partner_manager_mail"]: partner_user_email,
        ["outgoing_partner_delivery_post"]: partner_delivery_post,
        ["outgoing_partner_delivery_address"]: partner_delivery_address,
        ["outgoing_partner_delivery_address_add"]: partner_delivery_address_add,
    };
    setInputs(nextInputs);
  };
  
  const handleInputItemClick = (object) => {
    //품목 목록 모달에서 클릭한 값으로 출하 품목 데이터 설정함.
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(itemRows[i].outgoing_item_id === object.id && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.outgoing_item_id){
        processItemRowUpdate(
          {
            id: selectItemData.id,
            outgoing_item_id: object.id,
            outgoing_item_name: object.item_name,
            outgoing_item_spec: appStore.ITEM_FULL_SPEC_MAKE(object.item_spec, object.item_width, object.item_depth, object.item_height),
            outgoing_item_count: selectItemData.outgoing_item_count,
            outgoing_quality_exam_yn: selectItemData.outgoing_quality_exam_yn,
            outgoing_item_bigo: selectItemData.outgoing_item_bigo,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          },
          {
            id: selectItemData.id,
            outgoing_item_id: selectItemData.outgoing_item_id,
            outgoing_item_name: selectItemData.outgoing_item_name,
            outgoing_item_spec: selectItemData.outgoing_item_spec,
            outgoing_item_count: selectItemData.outgoing_item_count,
            outgoing_quality_exam_yn: selectItemData.outgoing_quality_exam_yn,
            outgoing_item_bigo: selectItemData.outgoing_item_bigo,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          }
        )
      }
    }
  };

  const handleUserClick = (object) => {
    //출하담당자 모달에서 클릭한 값으로 출하담당자 데이터 설정함.
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].outgoing_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.user_id){
        processUserRowUpdate(
          {
            id : selectUserData.id,
            outgoing_user_id: object.id,
            outgoing_user_name: object.user_name,
            outgoing_user_dept_name: object.dept_name,
            outgoing_user_position_name: object.position_name,
            outgoing_user_type: selectUserData.outgoing_user_type,
            outgoing_user_bigo: selectUserData.outgoing_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            outgoing_user_id: selectUserData.outgoing_user_id,
            outgoing_user_name: selectUserData.outgoing_user_name,
            outgoing_user_type: selectUserData.outgoing_user_type,
            outgoing_user_dept_name: selectUserData.outgoing_user_dept_name,
            outgoing_user_position_name: selectUserData.outgoing_user_position_name,
            outgoing_user_bigo: selectUserData.outgoing_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';
    if(inputs.outgoing_partner_id === 0 || inputs.outgoing_partner_id === ''){
      msg = '출하처는 필수 선택 입니다.'
    }else if((inputs.outgoing_date) === '' || (inputs.outgoing_date) < '2025-01-01' || (inputs.outgoing_date).length != 10){
      msg = '출하일자 입력이 올바르지 않습니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    }else if(inputs.outgoing_partner_manager_phone.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.outgoing_partner_manager_phone.trim())){
      msg = '담당자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자3,4자리-숫자4자리)';
    }else if(inputs.outgoing_partner_manager_mail.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.outgoing_partner_manager_mail.trim())){
      msg = '담당자 E-Mail 입력이 올바르지 않습니다.';
    }

    if(msg === '' && (itemRows.filter((data) => (data.update_type !== 'D' && (data.row_type !== 'A' || data.update_type !== 'N')))).length === 0){ // 입고품목이 0개 일 경우

      msg = '출하 품목이 존재하지 않습니다.';

    }else if(msg === '' && updateItemRows.length > 0){ // 입고품목 검사
      for(let i = 0; i < updateItemRows.length; i++) {
        const outgoing_item_id = updateItemRows[i].outgoing_item_id;
        const outgoing_item_count = updateItemRows[i].outgoing_item_count;

        if(outgoing_item_id === 0 || outgoing_item_id === '') {
          msg = '선택되지 않는 출하 품목이 존재합니다.';
          break;
        }
        if(outgoing_item_count === 0 || outgoing_item_count === '' || outgoing_item_count === null) {
          msg = '입력되지 않는 출하 수량이 존재합니다.';
          break;
        }
        if(outgoing_item_count < 0) {
          msg = '출하 수량은 음수가 될 수 없습니다.';
          break;
        }
      }
    }

    // 출하담당자
    if(msg === '' && (userRows.filter((data) => data.update_type === 'U')).length > 0){
      if(updateUserRows.length > 0 && msg === ''){
        for(let i = 0; i < updateUserRows.length; i++) {
          const outgoing_user_id = updateUserRows[i].outgoing_user_id;
          const outgoing_user_type = updateUserRows[i].outgoing_user_type;
          
          if(outgoing_user_id === 0 || outgoing_user_id === '') {
            msg = '선택되지 않는 담당자명이 존재합니다.';
            break;
          }
          if(outgoing_user_type === 0 || outgoing_user_type === '') {
            msg = '선택되지 않는 담당자유형이 존재합니다.';
            break;
          }
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">출하 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
        
      axios.post("/api/p/Outgoing/Reg", {inputs, updateItemRows, updateUserRows, updateLotRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          var selectID = response.data;
          if(String(selectID) === '-1'){
            Swal.fire({
              title: '<p style="color:red">출하 LotNo 변경 발생</p>',
              text: '출하 등록할 LotNo의 변경이 발생했습니다.',
              confirmButtonText: '확인'
            });
          }else{
            if(updateFileRows.length > 0) {
              
              const formData = new FormData();
              formData.append('selectID', selectID);
              formData.append('folder', 'Outgoing');
              formData.append('type', 'Update');
              formData.append('updateFileRows', JSON.stringify(updateFileRows));
              
              for(var i=0; i<realFiles.length; i++){            
                formData.append('files', realFiles[i]);
              }
              
              axios.post('/api/SaveCommon/GridFileSave'
                  , formData
                  , { headers: { 'Content-Type': 'multipart/form-data' } 
              }).then(response => {
                Swal.fire({
                  title: '출하 수정 완료',
                  text: '정상적으로 출하가 수정 되었습니다.',
                  confirmButtonText: '확인',
                  timer:5000,
                  timerProgressBar: true
                }).then((result) => {
                  handleView();
                });
              }).catch(error => {
                appStore.capture();
              });

            }else{

              Swal.fire({
                title: '출하 수정 완료',
                text: '정상적으로 출하가 수정 되었습니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
              }).then((result) => {
                handleView();
              });
              
            }
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });

    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="출하 정보" value="1" />
                <Tab label="출하 품목" value="2" />
                <Tab label="출하 Lot" value="3" />
                <Tab label="출하 담당자" value="4" />
                <Tab label="출하 파일" value="5" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="출하번호" value={inputs.outgoing_number} name="outgoing_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">수주번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="수주번호" value={inputs.outgoing_order_number} name="outgoing_order_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하일자<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="date" placeholder="출하일자" value={inputs.outgoing_date} name="outgoing_date" autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' }} readOnly />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하처<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="출하처" value={inputs.outgoing_partner_name} name="outgoing_partner_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', cursor: 'pointer'}} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하처담당자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="이름" value={inputs.outgoing_partner_manager} name="outgoing_partner_manager" onChange={(e) => onChange(e) } style={{ float: 'left', width: '112px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="휴대폰번호" value={inputs.outgoing_partner_manager_phone} name="outgoing_partner_manager_phone" onChange={(e) => onHypenChange(e) } style={{ float: 'left', width: '300px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="메일주소" value={inputs.outgoing_partner_manager_mail} name="outgoing_partner_manager_mail" onChange={(e) => onChange(e) } style={{width: '360px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하처배송지</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="우편번호" value={inputs.outgoing_partner_delivery_post} name="outgoing_partner_delivery_post" onChange={(e) => onChange(e) } style={{ float: 'left', width: '150px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="출하주소" value={inputs.outgoing_partner_delivery_address} name="outgoing_partner_delivery_address" onChange={(e) => onChange(e) } style={{width: '620px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title"></div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="상세주소" value={inputs.outgoing_partner_delivery_address_add} name="outgoing_partner_delivery_address_add" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="비고" name="outgoing_bigo" value={inputs.outgoing_bigo} onChange={(e) => onChange(e) } style={{width: '768px', height: '110px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processItemRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processLotRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="5" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'      
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                  <div className="modal_button" style={{float: 'left'}}>
                    {updateFlag &&
                     (originRows[0].outgoing_status === 'S'?
                      <Button 
                        onClick={ handleOutgoingCancel }
                        className="btn-p btn-u"
                        style={{width: '130px'}}
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "orange", 
                            backgroundColor: "orange",
                            ":hover": { boxShadow: "2px 2px 2px orange" , backgroundColor: "orange", borderColor: "orange"}
                        }} 
                        variant="outlined">
                        출하취소
                      </Button>
                    :
                      <Button 
                        onClick={ handleOutgoingCancel }
                        className="btn-p btn-u"
                        style={{width: '130px'}}
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#8041D9", 
                            backgroundColor: "#8041D9",
                            ":hover": { boxShadow: "2px 2px 2px #8041D9" , backgroundColor: "#8041D9", borderColor: "#8041D9"}
                        }} 
                        variant="outlined">
                        출하원복
                      </Button>
                      )
                    }
                    </div>
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {updateFlag &&
                      (originRows[0].outgoing_status === 'S'?
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        수정
                      </Button>:<></>
                      )}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectPartnerModalOpen && (<PartnerUserSelectModal
          onClose={() => {
              setSelectPartnerModalOpen(false);
          }}
          title={selectmodalTitle}
          handlePartnerUserClick={handlePartnerUserClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          handleInputItemClick={handleInputItemClick}
          />)}
        
        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </PCModal>
  );
}

export default OutgoingUpdateModal;